import { FC, useEffect } from 'react'
import { useStytchB2BClient, useStytchMemberSession, StytchB2BProvider, StytchB2B } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import { IAuthAdapter, WrapperProps } from '..'
import { discoveryConfig, discoveryStyles, SESSION_DURATION_MINUTES, stytchOptions } from './StytchAdapter.constants'
import { setPermissionsStytchUseCase } from '../../../refactory/modules/access-control/application/set-permissions-stytch.use-case'
import { authRepository } from '../../../refactory/modules/access-control/infrastructure/auth.repository'
import Session from '../../../Main/Services/User/session'
import { KEY_LOCAL_STORAGE_TOKEN } from '../../Auth.constants'

const StytchLoginComponent: FC<{ email?: string }> = ({ email }) => {
  useEffect(() => {
    if (email) {
      const setupEmailInput = () => {
        const emailInput = document.getElementById('email-input') as HTMLInputElement
        const passwordInput = document.getElementById('current-password') as HTMLInputElement

        if (emailInput) {
          emailInput.value = email

          const touchEvent = new Event('focus', { bubbles: true })
          const changeEvent = new Event('input', { bubbles: true })
          const blurEvent = new Event('blur', { bubbles: true })

          emailInput.dispatchEvent(touchEvent)
          emailInput.dispatchEvent(changeEvent)
          emailInput.dispatchEvent(blurEvent)

          if (passwordInput) {
            passwordInput.focus()
          }
        } else {
          setTimeout(setupEmailInput, 100)
        }
      }

      setTimeout(setupEmailInput, 50)
    }
  }, [email])

  const callbacks = {
    onEvent: ({ type }) => {
      if (type === 'B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE') {
        window.location.href = `/?provider=stytch`
      }
    },
    onError: (error) => {
      throw new Error('error init auth stytch: ' + JSON.stringify(error))
    }
  }

  return <StytchB2B config={discoveryConfig} styles={discoveryStyles} callbacks={callbacks} />
}

export function useStytchAdapter(): IAuthAdapter {
  const { session } = useStytchMemberSession()
  const stytch = useStytchB2BClient()

  const init = async () => {}

  const redirectLogin = async () => {}

  const getRenderLogin = (email?: string) => {
    return <StytchLoginComponent email={email} />
  }

  const isAuthenticated = async () => {
    return !!session
  }

  const generateToken = async () => {
    const { session_jwt, session_token } = await stytch.session.getTokens()
    Session.set(KEY_LOCAL_STORAGE_TOKEN, session_jwt)

    await setPermissionsStytchUseCase(authRepository)()
    await stytch.session.updateSession({
      session_token,
      session_jwt
    })
    await stytch.session.authenticate({ session_duration_minutes: SESSION_DURATION_MINUTES })

    const updatedTokens = await stytch.session.getTokens()
    Session.set(KEY_LOCAL_STORAGE_TOKEN, updatedTokens.session_jwt)
    return updatedTokens.session_jwt
  }

  const logout = async () => {
    try {
      await stytch.session.revoke()
    } catch (_) {}
  }

  return {
    init,
    getRenderLogin,
    redirectLogin,
    isAuthenticated,
    generateToken,
    logout
  }
}

export const GetWrapperStytch: FC<WrapperProps> = ({ children }) => {
  return (
    <StytchB2BProvider stytch={new StytchB2BUIClient(process.env.REACT_APP_STYTCH_PUBLIC_TOKEN, stytchOptions)}>
      {children}
    </StytchB2BProvider>
  )
}
